import { render, staticRenderFns } from "./NewKnowledgeChooseType.vue?vue&type=template&id=6a242e44&scoped=true&"
import script from "./NewKnowledgeChooseType.vue?vue&type=script&lang=js&"
export * from "./NewKnowledgeChooseType.vue?vue&type=script&lang=js&"
import style0 from "./NewKnowledgeChooseType.vue?vue&type=style&index=0&id=6a242e44&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a242e44",
  null
  
)

export default component.exports